/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationdismissedbadge2Inputs */

const en_moderationdismissedbadge2 = /** @type {(inputs: Moderationdismissedbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismissed`)
};

const de_moderationdismissedbadge2 = /** @type {(inputs: Moderationdismissedbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verworfen`)
};

/**
* | output |
* | --- |
* | "Dismissed" |
*
* @param {Moderationdismissedbadge2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationdismissedbadge2 = /** @type {((inputs?: Moderationdismissedbadge2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationdismissedbadge2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationdismissedbadge2(inputs)
	return de_moderationdismissedbadge2(inputs)
});
export { moderationdismissedbadge2 as "moderationDismissedBadge" }